export default __webpack_public_path__ + "static/media/polka-dot-man.a7db4792.png";